import { startRegistration, startAuthentication, browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from "@simplewebauthn/browser";
import { api } from "@/lib/api";

const KEY = "pk_login_id";
export const savedPasskeyId = () => localStorage.getItem(KEY) || "";

export async function passkeySupported() {
  if (!browserSupportsWebAuthn()) return false;
  try { return await platformAuthenticatorIsAvailable(); } catch { return false; }
}

const cancelled = (e) => (e?.name === "NotAllowedError" ? new Error("تم إلغاء البصمة أو انتهت مهلتها") : e);

export async function registerPasskey(loginId) {
  const { data } = await api.post("/passkeys/register/options");
  let credential;
  try { credential = await startRegistration({ optionsJSON: data }); } catch (e) { throw cancelled(e); }
  await api.post("/passkeys/register/verify", { credential, device: navigator.userAgent });
  localStorage.setItem(KEY, loginId);
}

export async function loginWithPasskey(loginId) {
  const { data } = await api.post("/passkeys/login/options", { phone: loginId });
  let credential;
  try { credential = await startAuthentication({ optionsJSON: data }); } catch (e) { throw cancelled(e); }
  const res = await api.post("/passkeys/login/verify", { phone: loginId, credential });
  localStorage.setItem(KEY, loginId);
  return res.data;
}

export const forgetPasskeyId = () => localStorage.removeItem(KEY);
